export const primary = {
  100: 'hsl(233, 27%, 94%)',
  300: 'hsl(232, 24%, 82%)',
  500: 'hsl(231, 76%, 45%)',
  700: 'hsl(232, 76%, 25%)',
  800: 'hsl(233, 32%, 30%)',
  900: 'hsl(232, 77%, 12%)',
};
export const green = {
  100: 'hsl(125, 80%, 96%)',
  300: 'hsl(125, 50%, 77%)',
  500: 'hsl(125, 50%, 60%)',
  700: 'hsl(125, 50%, 37%)',
  900: 'hsl(125, 70%, 12%)',
};
export const yellow = {
  100: 'hsl(36, 100%, 85%)',
  300: 'hsl(36, 91%, 68%)',
  500: 'hsl(36, 100%, 50%)',
  700: 'hsl(36, 97%, 40%)',
  900: 'hsl(36, 100%, 25%)',
};
export const pink = {
  100: 'hsl(332, 75%, 92%)',
  300: 'hsl(333, 84%, 75%)',
  500: 'hsl(333, 94%, 61%)',
  700: 'hsl(333, 58%, 40%)',
  900: 'hsl(333, 59%, 15%)',
};

export default {
  primary,
  green,
  yellow,
  pink,
};
